module.exports = __webpack_public_path__ + "static/img/20221222094853555.c82bea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/20221222094853555.jpg
// module id = UtO7
// module chunks = 30